export enum PricingPlanType {
    none = 0,
    basic = 1,
    popular = 2,
    executive = 3,
    enterprise = 4
}